import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const RequiredField = props => {
  const { required, isEmpty } = props;

  return (
    <div style={{ display: 'inline' }}>
      &nbsp;
      { required && isEmpty
        ? <p style={{ display: 'inline', color: 'red' }}>*</p>
        : <FontAwesomeIcon
          icon={['fas', 'check']}
          color="green"
          size="xs"
        />
      }
    </div>
  );
};
